/* Fotobaren — Tilvalg gate.
   Add-ons from the booking-tilvalg collection can only be bought when the
   customer has an open fotobar booking. Lookup is by email + ordrenummer
   (Make webhook → Shopify Admin). On success we stamp cart attributes so the
   Tilvalg→Podio Make scenario can attach the order to the right booking. */
(function () {
  'use strict';

  var STORAGE_KEY = 'fb-tilvalg-booking';
  var ATTRS = {
    type: 'Booking: type',
    email: 'Booking: e-post',
    linked: 'Booking: linked-order',
    fra: 'Booking: fra',
    til: 'Booking: til',
    anledning: 'Booking: anledning',
  };

  function config() {
    var el = document.querySelector('[data-fb-booking-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function tilvalgIds() {
    var c = config();
    if (!c || !c.addons) return [];
    return c.addons.map(function (a) { return String(a.variantId); });
  }

  function lookupUrl() {
    var c = config();
    return (c && c.tilvalgLookupUrl) || '';
  }

  function loadVerified() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  function saveVerified(data) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function clearVerified() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function dayKey(iso) {
    return String(iso || '').slice(0, 10);
  }

  function diffDays(a, b) {
    var pa = String(a).slice(0, 10).split('-').map(Number);
    var pb = String(b).slice(0, 10).split('-').map(Number);
    return Math.round((new Date(pb[0], pb[1] - 1, pb[2]) - new Date(pa[0], pa[1] - 1, pa[2])) / 86400000);
  }

  /** Match wizard: delivery lead + addon extra (AI +2, egen logo +1, or tag lead-N). */
  function deliveryLeadDays(levering, postnr) {
    var t = String(levering || '').toLowerCase();
    if (/ekspress/.test(t)) return 2;
    if (/budbil/.test(t)) return 1;
    if (/hent/.test(t)) return 1;
    var n = parseInt(String(postnr || '').replace(/\D/g, ''), 10);
    if (!isNaN(n)) {
      var region = (n < 1400) ? 'oslo' : ([4, 5, 7].indexOf(Math.floor(n / 1000)) !== -1 ? 'storby' : 'distrikt');
      return region === 'distrikt' ? 10 : 7;
    }
    return 7;
  }

  function addonExtraLeadFromTitle(title, tags) {
    var tagStr = String(tags || '').toLowerCase();
    var m = tagStr.match(/\blead-(\d+)\b/);
    if (m) return parseInt(m[1], 10) || 0;
    var t = String(title || '').toLowerCase();
    if (/ai[\s-]*filter|green\s*screen|skreddersydd\s*ai|standard\s*ai/.test(t)) return 2;
    if (/egen\s*logo|eget\s*logo|custom\s*logo/.test(t)) return 1;
    return 0;
  }

  function tilvalgLeadOk(booking, productTitle) {
    var du = diffDays(todayKey(), dayKey(booking.fra));
    var extra = addonExtraLeadFromTitle(productTitle, '');
    if (extra <= 0) return { ok: true };
    var need = deliveryLeadDays(booking.levering, booking.postnr) + extra;
    if (du >= need) return { ok: true };
    var earliest = (function () {
      var d = new Date();
      d.setDate(d.getDate() + need);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + day;
    })();
    return {
      ok: false,
      need: need,
      message: 'Dette tilvalget krever ca. ' + need + ' dager før arrangementet (' +
        fmtDay(booking.fra) + ') med valgt levering. Det er for kort tid nå. ' +
        'Tidligste dato som vanligvis funker er ca. ' + fmtDay(earliest) +
        ' — endre eventdato under Min booking, eller kontakt oss.',
    };
  }

  function fmtDay(iso) {
    var key = dayKey(iso);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return iso || '';
    var p = key.split('-');
    var months = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];
    return parseInt(p[2], 10) + '. ' + months[parseInt(p[1], 10) - 1];
  }

  function todayKey() {
    return new Date().toISOString().slice(0, 10);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Cart already contains a rental being booked in this session — no gate. */
  function cartHasRental(cart) {
    return (cart.items || []).some(function (i) {
      return i.properties && i.properties.__izyrentValidation;
    });
  }

  function cartHasTilvalg(cart, ids) {
    var set = {};
    ids.forEach(function (id) { set[id] = true; });
    return (cart.items || []).some(function (i) { return set[String(i.variant_id)]; });
  }

  function formIsTilvalg(form) {
    var ids = tilvalgIds();
    if (!ids.length) return false;
    var input = form.querySelector('[name="id"]');
    if (!input) return false;
    return ids.indexOf(String(input.value)) !== -1;
  }

  function stampCart(data) {
    var attributes = {};
    attributes[ATTRS.type] = 'tilvalg';
    attributes[ATTRS.email] = data.email;
    attributes[ATTRS.linked] = String(data.order).replace(/^#/, '');
    if (data.fra) attributes[ATTRS.fra] = data.fra;
    if (data.til) attributes[ATTRS.til] = data.til;
    if (data.anledning) attributes[ATTRS.anledning] = data.anledning;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    });
  }

  function lookup(email, order) {
    var url = lookupUrl();
    if (!url) return Promise.reject(new Error('missing-url'));
    var payload = { email: email };
    if (order) payload.order = String(order).replace(/^#/, '').trim();
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      if (!r.ok) throw new Error('lookup-http');
      return r.json();
    });
  }

  /* ---- modal ---- */
  var modal = null;
  var pending = null; // { resolve, reject }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'fb-tilvalg-gate';
    modal.className = 'fb-tg';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="fb-tg__backdrop" data-fb-tg-close></div>' +
      '<div class="fb-tg__panel" role="dialog" aria-modal="true" aria-labelledby="fb-tg-title">' +
        '<button type="button" class="fb-tg__close" data-fb-tg-close aria-label="Lukk">×</button>' +
        '<h2 id="fb-tg-title">Kobling til booking</h2>' +
        '<p class="fb-tg__sub">Tilvalg kan bare kjøpes hvis du har en aktiv fotobar-booking. Skriv inn e-post og ordrenummer fra bekreftelsen.</p>' +
        '<label class="fb-tg__label" for="fb-tg-email">E-post</label>' +
        '<input id="fb-tg-email" class="fb-tg__input" type="email" autocomplete="email" placeholder="ola@epost.no">' +
        '<label class="fb-tg__label" for="fb-tg-order">Ordrenummer</label>' +
        '<input id="fb-tg-order" class="fb-tg__input" type="text" inputmode="numeric" autocomplete="off" placeholder="f.eks. 6057">' +
        '<div class="fb-tg__msg" data-fb-tg-msg hidden></div>' +
        '<button type="button" class="fb-tg__btn" data-fb-tg-submit>Finn booking</button>' +
        '<p class="fb-tg__hint">Ordrenummeret står i bekreftelses-e-posten. Ingen booking? <a href="#fb-booking">Reserver fotobar først</a></p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-fb-tg-close]')) {
        closeModal(new Error('cancelled'));
      }
    });
    modal.querySelector('[data-fb-tg-submit]').addEventListener('click', onSubmit);
    function onEnter(e) {
      if (e.key === 'Enter') { e.preventDefault(); onSubmit(); }
    }
    modal.querySelector('#fb-tg-email').addEventListener('keydown', onEnter);
    modal.querySelector('#fb-tg-order').addEventListener('keydown', onEnter);
    return modal;
  }

  function setMsg(text, kind) {
    var el = modal.querySelector('[data-fb-tg-msg]');
    if (!text) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.className = 'fb-tg__msg' + (kind ? ' fb-tg__msg--' + kind : '');
    el.textContent = text;
  }

  function openModal() {
    ensureModal();
    var v = loadVerified();
    modal.querySelector('#fb-tg-email').value = (v && v.email) || '';
    modal.querySelector('#fb-tg-order').value = (v && v.order) || '';
    setMsg('');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { modal.querySelector('#fb-tg-email').focus(); }, 50);
    return new Promise(function (resolve, reject) {
      pending = { resolve: resolve, reject: reject };
    });
  }

  function closeModal(err) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (pending) {
      var p = pending;
      pending = null;
      if (err) p.reject(err);
    }
  }

  function onSubmit() {
    var input = modal.querySelector('#fb-tg-email');
    var orderInput = modal.querySelector('#fb-tg-order');
    var email = (input.value || '').trim().toLowerCase();
    var order = ((orderInput && orderInput.value) || '').replace(/^#/, '').trim();
    if (!/.+@.+\..+/.test(email)) {
      setMsg('Skriv inn en gyldig e-postadresse.', 'err');
      return;
    }
    if (!/^\d+$/.test(order)) {
      setMsg('Skriv inn ordrenummeret (kun siffer, f.eks. 6057).', 'err');
      return;
    }
    var btn = modal.querySelector('[data-fb-tg-submit]');
    btn.disabled = true;
    btn.textContent = 'Søker…';
    setMsg('');
    lookup(email, order).then(function (data) {
      btn.disabled = false;
      btn.textContent = 'Finn booking';
      if (!data || !data.ok || !data.order || !data.fra) {
        setMsg('Fant ingen fotobar-booking med denne e-posten og ordrenummeret.', 'err');
        return;
      }
      if (String(data.order).replace(/^#/, '') !== order) {
        setMsg('Ordrenummeret matcher ikke bookingen vi fant. Sjekk bekreftelsen.', 'err');
        return;
      }
      if (dayKey(data.fra) < todayKey()) {
        setMsg('Bookingen vi fant har allerede passert. Tilvalg kan bare legges til før arrangementet.', 'err');
        return;
      }
      var verified = {
        email: data.email || email,
        order: String(data.order).replace(/^#/, ''),
        fra: dayKey(data.fra),
        til: dayKey(data.til) || '',
        anledning: data.anledning || '',
        levering: data.levering || '',
        postnr: data.postnr || '',
      };
      saveVerified(verified);
      setMsg('Fant booking #' + verified.order + ' · ' + (verified.anledning ? verified.anledning + ' · ' : '') + fmtDay(verified.fra), 'ok');
      stampCart(verified).then(function () {
        var p = pending;
        pending = null;
        setTimeout(function () {
          modal.hidden = true;
          document.body.style.overflow = '';
          if (p) p.resolve(verified);
        }, 600);
      }).catch(function () {
        setMsg('Bookingen er funnet, men handlekurven kunne ikke oppdateres. Prøv igjen.', 'err');
      });
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Finn booking';
      setMsg('Klarte ikke å slå opp bookingen akkurat nå. Prøv igjen om litt.', 'err');
    });
  }

  function ensureVerified() {
    var v = loadVerified();
    if (v && v.order && v.email && dayKey(v.fra) >= todayKey()) {
      return stampCart(v).then(function () { return v; });
    }
    if (!lookupUrl()) {
      return Promise.reject(new Error('missing-url'));
    }
    return openModal();
  }

  /* ---- intercept add-to-cart on tilvalg PDPs ---- */
  function isProductForm(form) {
    return form && (form.getAttribute('is') === 'product-form' || form.dataset.type === 'add-to-cart-form');
  }

  function bindAtc() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isProductForm(form)) return;
      if (form.dataset.fbTilvalgOk === '1') {
        delete form.dataset.fbTilvalgOk;
        return; // allow this submit through
      }
      if (!formIsTilvalg(form) || !tilvalgIds().length) return;
      if (!lookupUrl()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('Tilvalg-kjøp er ikke konfigurert ennå. Kontakt oss, så hjelper vi deg.');
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var titleEl = document.querySelector('h1, .product-title, [data-product-title]');
        var productTitle = (titleEl && titleEl.textContent) || document.title || '';
        var proceed = function (booking) {
          if (booking) {
            var lead = tilvalgLeadOk(booking, productTitle);
            if (!lead.ok) {
              alert(lead.message);
              return;
            }
          }
          form.dataset.fbTilvalgOk = '1';
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else HTMLFormElement.prototype.submit.call(form);
        };
        if (cartHasRental(cart)) {
          // Rental in cart — wizard already enforced addon lead against its date/delivery.
          proceed(null);
          return;
        }
        ensureVerified().then(proceed).catch(function (err) {
          if (err && err.message === 'cancelled') return;
        });
      });
    }, true);
  }

  /* ---- cart page / drawer: block checkout if tilvalg without link ---- */
  function bindCheckoutGuard() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="/checkout"], button[name="checkout"], [href*="/checkout"]');
      if (!a) return;
      var ids = tilvalgIds();
      if (!ids.length || !lookupUrl()) return;

      e.preventDefault();
      e.stopPropagation();

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!cartHasTilvalg(cart, ids) || cartHasRental(cart)) {
          window.location.href = '/checkout';
          return;
        }
        var attrs = cart.attributes || {};
        if (attrs[ATTRS.type] === 'tilvalg' && attrs[ATTRS.linked]) {
          window.location.href = '/checkout';
          return;
        }
        ensureVerified().then(function () {
          window.location.href = '/checkout';
        }).catch(function (err) {
          if (err && err.message === 'cancelled') return;
        });
      });
    }, true);
  }

  function showVerifiedBadge() {
    var v = loadVerified();
    var ids = tilvalgIds();
    if (!v || !ids.length) return;
    document.querySelectorAll('[data-fb-tilvalg-product]').forEach(function (el) {
      if (el.querySelector('.fb-tg__badge')) return;
      var b = document.createElement('div');
      b.className = 'fb-tg__badge';
      b.innerHTML = 'Koblet til booking <strong>#' + esc(v.order) + '</strong> · ' + esc(fmtDay(v.fra)) +
        ' <button type="button" class="fb-tg__badge-clear">Bytt e-post</button>';
      b.querySelector('.fb-tg__badge-clear').addEventListener('click', function () {
        clearVerified();
        b.remove();
        openModal().catch(function () {});
      });
      el.insertBefore(b, el.firstChild);
    });
  }

  function init() {
    var c = config();
    if (!c || !c.addons || !c.addons.length) return;
    bindAtc();
    bindCheckoutGuard();
    showVerifiedBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
